import {
    Grid,
    pxToRem,
    Checkbox,
    useStyles,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { useState } from 'react';
import { DigitalMagazineOptions } from '~/modules/magazine/configs/constants';
import type {
    CategoryFilterType,
    FilterStates,
} from '~/modules/magazine/type/filter-states';
import * as S from './CategoryFilters.style';

interface CategoryFiltersProps {
    onChange: (filter: CategoryFilterType) => void;
    filterStates: FilterStates;
}

export const CategoryFilters = ({
    onChange,
    filterStates,
}: CategoryFiltersProps) => {
    const { desktop } = useAppDisplayModeContext();
    const [param, setParam] = useState(filterStates.categoryEnum);

    const { css } = useStyles();

    return (
        <Grid columns={'100%'} className={css(S.CategoryFilters)}>
            {DigitalMagazineOptions.map((s) => {
                const checked =
                    s.searchEnum === param || (!s.searchEnum && !param);
                return (
                    <Checkbox
                        key={s.key}
                        checked={checked}
                        onChange={() => {
                            setParam(s.searchEnum);
                            onChange(s.searchEnum);
                        }}
                        indicator={{
                            kind: 'radio',
                            indicator: {
                                design: desktop
                                    ? {
                                          display: 'none',
                                      }
                                    : {},
                                variables: {
                                    middleRingColor: 'white',
                                    checkedBackgroundColor: '#343434',
                                    border: `2px solid #343434`,
                                },
                            },
                        }}
                        label={{
                            children: s.label,
                            className: checked ? css(S.Active) : '',
                            variables: {
                                fontSize: pxToRem(desktop ? 30 : 16),
                                lineHeight: 1,
                            },
                        }}
                        variables={{
                            radioIndicatorLabelGap: pxToRem(desktop ? 0 : 5.3),
                            radioIndicatorLabelCheckedGap: pxToRem(
                                desktop ? 0 : 5.3
                            ),

                            labelLineHeight: pxToRem(desktop ? 30 : 16),
                        }}
                        className={css(S.CategoryFilter)}
                    />
                );
            })}
        </Grid>
    );
};
